import URI from "urijs";

import URIExpand from "@app/lib/uri-expand";
import { buildUrl } from "@app/services/url-builders/url-builder-helpers";

import type { SupportedLocale } from "@config/locales";

import {
  about_link_template,
  about_partners_link_template,
  affiliate_link_template,
  affiliate_products_link_template,
  blog_link_template,
  careers_link_template,
  contact_link_template,
  distribution_link_template,
  help_link_template,
  impressum_link_template,
  press_link_template,
  privacy_link_template,
  refunds_link_template,
  terms_of_use_link_template
} from "../../../config/link-templates";

export function aboutUrl(locale: SupportedLocale): string {
  const uri = URIExpand(about_link_template, {
    locale
  });

  return buildUrl(uri);
}

export function blogUrl(locale: SupportedLocale): string {
  const uri = URIExpand(blog_link_template[locale], {
    locale
  });

  return buildUrl(uri);
}

export function aboutPartnersUrl(locale: SupportedLocale): string {
  const uri = URIExpand(about_partners_link_template, {
    locale
  });

  return buildUrl(uri);
}

export function affiliatePageUrl(locale: SupportedLocale): string {
  const uri = URIExpand(affiliate_link_template[locale], {
    locale
  });

  return buildUrl(uri);
}

export function distributionPageUrl(locale: SupportedLocale): string {
  const uri = URIExpand(distribution_link_template[locale], {
    locale
  });

  return buildUrl(uri);
}

export function careersUrl(locale: SupportedLocale): string {
  const uri = URIExpand(careers_link_template, {
    locale
  });

  return buildUrl(uri);
}

export function pressUrl(locale: SupportedLocale): string {
  const uri = URIExpand(press_link_template, {
    locale
  });

  return buildUrl(uri);
}

export function refundsUrl(locale: SupportedLocale): string {
  const url = URIExpand(refunds_link_template, {
    locale
  });

  return buildUrl(url);
}

export function privacyUrl(locale: SupportedLocale): string {
  const url = URIExpand(privacy_link_template, {
    locale
  });

  return buildUrl(url);
}

export function termsOfUseUrl(locale: SupportedLocale): string {
  const url = URIExpand(terms_of_use_link_template, {
    locale
  });

  return buildUrl(url);
}

export function affiliateProductsUrl(locale: SupportedLocale) {
  return affiliate_products_link_template[locale];
}

export function impressumUrl(locale: SupportedLocale): string {
  const uri = URIExpand(impressum_link_template, {
    locale
  });

  return buildUrl(uri);
}

export function contactUrl(locale: SupportedLocale): string {
  const uri = URIExpand(contact_link_template, {
    locale
  });

  return buildUrl(uri);
}

export function helpUrl(
  locale: SupportedLocale,
  params: {
    purchase_id?: number | undefined;
    purchase_uuid?: string | undefined;
    travel_review_id?: string | undefined;
    form?: string;
  } = {}
): string {
  const { purchase_id, purchase_uuid, travel_review_id, form } = params;
  const uri = URI(help_link_template[locale]);

  uri.query({
    purchase_id,
    purchase_uuid,
    travel_review_id,
    form
  });

  return buildUrl(uri);
}
